import React from 'react'
import { connect } from 'react-redux'
import { Route, Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import './mainMenu.css'

export const MainMenu = ({links}) => <header>
	{links.map(({path, name, active}) =>
		<Link to={path} key={path} className={active?'active':''}>{name}</Link>)}
</header>

MainMenu.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.exact({
			path: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			active: PropTypes.bool.isRequired,
		})
	).isRequired,
}

export const mapStateToProps = ({pages}, {location: {pathname}}) => ({
	links: pages
		.filter(({published}) => published)
		.filter(({menu}) => menu === 'Mainmenu')
		.sort((a, b) => a.order - b.order)
		.map(({
			path,
			title,
		}) => ({
			path,
			name: title,
			active: path.split('/')[1] === pathname.split('/')[1],
		})),
})

const connectedMainMenu = () =>
	<Route path={'/'} component={connect(
		mapStateToProps
	)(MainMenu)} />

export default connectedMainMenu



// WEBPACK FOOTER //
// ./src/components/mainMenu.jsx